"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertType = assertType;
exports.checkParams = checkParams;
exports.hasExactParamsLength = hasExactParamsLength;
exports.hasRequiredParams = hasRequiredParams;
exports.hasRequiredParamsLength = hasRequiredParamsLength;
exports.methodEndsWith = methodEndsWith;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function assertType(obj, key) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "string";

  if (!obj[key] || _typeof(obj[key]) !== type) {
    throw new Error("Missing or invalid \"".concat(key, "\" param"));
  }
}

function hasRequiredParams(params, required) {
  var matches = true;
  required.forEach(function (key) {
    var exists = (key in params);

    if (!exists) {
      matches = false;
    }
  });
  return matches;
}

function hasExactParamsLength(params, length) {
  return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}

function hasRequiredParamsLength(params, minLength) {
  return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}

function checkParams(params, required, optional) {
  var exact = !optional.length;
  var matchesLength = exact ? hasExactParamsLength(params, required.length) : hasRequiredParamsLength(params, required.length);
  if (!matchesLength) return false;
  return hasRequiredParams(params, required);
}

function methodEndsWith(method, expected) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  var split = method.split(separator);
  return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}